/**
 * Compare
 */

// Import extend function.
import Component from '../../js/core/component.js';

class Compare extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.element = this.settings.element;

		if(this.element) {
			this.checkboxes = this.element.querySelectorAll('.c-compare__checkbox');
			this.controls = this.element.querySelector('.c-compare__controls');
			this.compareBtn = this.controls.querySelector('.c-compare__compare');
			this.compareCount = this.controls.querySelector('.c-compare__count');
			this.clearBtn = this.controls.querySelector('.c-compare__clear');

			this._countChecked();

			this.element.addEventListener('change', () => {
				this._countChecked();
			});

			this.clearBtn.addEventListener('click', () => {
				this._clearChecked();
			});
		}
	}

	/**
	 * Show compare controls
	 */
	_showControls () {
		if (!this.controls.classList.contains('c-compare__controls--show')) {
			this.controls.classList.add('c-compare__controls--show');
		}
	}

	/**
	 * Count checked checkboxes
	 */
	_countChecked () {
		var count = 0;

		this.checkboxes.forEach((checkbox) => {
			if (checkbox.checked) {
				count += 1;
			}
		});

		if (count !== 0) {
			this._showControls();
			this.compareCount.innerHTML = '(' + count + ')';
		}
		else {
			this.controls.classList.remove('c-compare__controls--show');
		}
	}

	/**
	 * Clear checked checkboxes
	 */
	_clearChecked () {
		this.checkboxes.forEach((checkbox) => {
			checkbox.checked = false;
		});
		this._countChecked();
	}
}

document.addEventListener('newcontent', (e) => {
	const compareElem = e.target.querySelector('.c-compare');
	if(compareElem) {
		compareElem.compare = new Compare({
			element: compareElem
		});
	}
});

export default Compare;


// WEBPACK FOOTER //
// ./components/compare/c-compare.js